import { z } from 'zod';

import { DateStringSchema } from '../../common';
import { buildQueryString } from '../../utils/querystring';
import { BookingWithParticipantSchema } from '../booking/booking-participants-for-event';
import { makeEndpoint } from '../common';

export const EventParticipantsResponse = z.object({
  items: z.array(BookingWithParticipantSchema),
});

export const GetParticipantsForCollectionWebsocketSchema = z.object({
  collectionId: z.string().uuid(),
  eventDate: DateStringSchema,
  brandId: z.string().uuid(),
});

export const GetCollectionEventParticipantsQuerySchema = z.object({
  eventDate: DateStringSchema,
  brandId: z.string().uuid(),
  q: z.string().optional(),
});

export const GetEventParticipantsQuerySchema = z.object({
  q: z.string().optional(),
});
export type GetEventParticipantsQuery = z.infer<typeof GetEventParticipantsQuerySchema>;

export const GetCollectionEventParticipantsEndpoint = makeEndpoint({
  method: 'GET',
  url: ({
    collectionId,
    query,
  }: {
    collectionId: string;
    query: z.input<typeof GetCollectionEventParticipantsQuerySchema>;
  }) => `/v1/collection/${collectionId}/participants?${buildQueryString(query)}`,
  responseSchema: EventParticipantsResponse,
  requestSchema: z.void(),
  querySchema: GetCollectionEventParticipantsQuerySchema,
});

export const GetEventParticipantsEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ eventId, ...query }: { eventId: string } & GetEventParticipantsQuery) => {
    const entries = Object.entries(query).filter((keyValue): keyValue is [string, string] => keyValue[1] !== undefined);
    return `events/${eventId}/participants?${new URLSearchParams(Object.fromEntries(entries)).toString()}`;
  },
  responseSchema: EventParticipantsResponse,
  requestSchema: z.void(),
});

const ParticipantsCheckInSchema = z.object({
  items: z.array(BookingWithParticipantSchema),
});

export const PostParticipantsCheckInEndpoint = makeEndpoint({
  method: 'POST',
  url: ({ eventId }: { eventId: string }) => `v1/events/${eventId}/participants/check-in`,
  responseSchema: ParticipantsCheckInSchema,
  requestSchema: z.object({
    participantIds: z.array(z.string()),
  }),
});

export const PostParticipantsCheckOutEndpoint = makeEndpoint({
  method: 'POST',
  url: ({ eventId }: { eventId: string }) => `v1/events/${eventId}/participants/check-out`,
  responseSchema: ParticipantsCheckInSchema,
  requestSchema: z.object({
    participantIds: z.array(z.string()),
  }),
});
